export default "__VITE_ASSET__DS$B_Ogd__"